var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMlpCoin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 79,
    viewBox: "0 0 78 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.7919 35.1974L37.3281 37.2945C37.2188 37.2222 35.1473 35.8475 33.5469 35.5387L37.0106 33.4417C38.6122 33.7516 40.6837 35.1263 40.7919 35.1985",
    fill: "#08091B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6221 24.9547L13.6221 24.9547C18.2783 22.6797 24.0234 23.1226 29.6443 25.9425C35.2568 28.7581 40.6113 33.8917 44.3048 40.7069C47.9991 47.5234 49.2747 54.6219 48.4319 60.5523C47.5897 66.4782 44.664 71.1337 40.0254 73.4002C35.3692 75.6752 29.6241 75.2325 24.0031 72.4127C18.3905 69.597 13.0357 64.4632 9.34154 57.6468C5.64669 50.8291 4.37117 43.7309 5.21422 37.8011C6.05661 31.8761 8.98272 27.2212 13.6221 24.9547Z",
    fill: "url(#paint0_linear_4334_14384)",
    stroke: "url(#paint1_linear_4334_14384)",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2017 39.1532L29.1994 38.458L24.8081 34.8021L26.2017 39.1532Z",
    fill: "#CAFFCA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9861 63.4396L35.4943 63.0896L34.0886 43.6252L33.5715 43.1946L27.9216 44.5052L33.9861 63.4396Z",
    fill: "#CAFFCA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2301 40.7712L22.2279 40.0761L20.8086 35.644L19.2301 40.7712Z",
    fill: "#CAFFCA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2194 47.4822L28.7572 64.6524L30.0079 64.3628L23.9431 45.4277L18.4618 46.6986L18.2194 47.4822Z",
    fill: "#CAFFCA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5662 45.7031L16.5704 42.5933L23.4655 40.9938L21.24 34.0466L23.4689 33.5291L25.6942 40.4772L32.5892 38.8776L33.585 41.9874L26.69 43.587L33.1132 63.6429L30.8845 64.1594L24.4612 44.1035L17.5662 45.7031Z",
    fill: "#03F5AE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.12 59.9044L39.6562 62.0015C39.8283 61.9008 39.9903 61.7837 40.1401 61.652L43.6038 59.5549C43.4543 59.6869 43.2922 59.804 43.12 59.9044Z",
    fill: "#027F5A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6682 27.186L12.2033 29.2831C12.1661 29.3018 12.1417 29.3157 12.1289 29.3239L15.5926 27.2268C15.6054 27.2198 15.6298 27.2058 15.6682 27.1872",
    fill: "#08091B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5887 27.2314L12.125 29.3285L12.1331 29.3227L15.5969 27.2256H15.5887",
    fill: "#027F5A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1004 59.9489L20.6367 62.046C20.7335 61.9902 20.8257 61.9267 20.9124 61.8561L24.3773 59.759C24.2898 59.8291 24.1973 59.8925 24.1004 59.9489Z",
    fill: "#027F5A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.753387 37.1869L4.21828 35.0898V35.0887C5.39651 30.4215 7.94255 26.5745 11.7552 24.2654L8.29148 26.3625C4.47533 28.6716 1.93278 32.5197 0.753387 37.1869ZM13.8011 66.4603L13.8004 66.4606C11.5454 64.0127 9.60418 61.2925 8.02164 58.3631C3.67396 50.3417 2.50969 41.8555 4.2183 35.0912L0.7534 37.1883C-0.954038 43.9526 0.210225 52.4376 4.55791 60.4602C6.14022 63.3898 8.08174 66.1099 10.3374 68.5573L10.3374 68.5573C18.293 77.1601 29.0634 80.83 37.2191 76.8467C37.6354 76.6401 38.0375 76.4203 38.4252 76.1873L41.8652 74.1052C41.4837 74.3356 41.0896 74.55 40.6828 74.7484C32.5271 78.7329 21.7567 75.0618 13.8011 66.4603Z",
    fill: "#4B437C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_f_4334_14384)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.3461,
    cy: 47.2034,
    rx: 16.2746,
    ry: 6.97484,
    transform: "rotate(53.1138 33.3461 47.2034)",
    fill: "black"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2081 13.1974L40.6719 15.2945C40.7812 15.2222 42.8527 13.8475 44.4531 13.5387L40.9894 11.4417C39.3878 11.7516 37.3163 13.1263 37.2081 13.1985",
    fill: "#08091B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3779 2.95468L64.3779 2.95465C59.7217 0.679652 53.9766 1.12262 48.3557 3.94247C42.7432 6.75813 37.3887 11.8917 33.6952 18.7069C30.0009 25.5234 28.7253 32.6219 29.5681 38.5523C30.4103 44.4782 33.336 49.1337 37.9746 51.4002C42.6308 53.6752 48.3759 53.2325 53.9969 50.4127C59.6095 47.597 64.9643 42.4632 68.6585 35.6468C72.3533 28.8291 73.6288 21.7309 72.7858 15.8011C71.9434 9.87606 69.0173 5.22123 64.3779 2.95468Z",
    fill: "url(#paint2_linear_4334_14384)",
    stroke: "url(#paint3_linear_4334_14384)",
    strokeWidth: 3
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7983 17.1532L48.8006 16.458L53.1919 12.8021L51.7983 17.1532Z",
    fill: "#CAFFCA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0139 41.4396L42.5057 41.0896L43.9114 21.6252L44.4285 21.1946L50.0784 22.5052L44.0139 41.4396Z",
    fill: "#CAFFCA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7699 18.7712L55.7721 18.0761L57.1914 13.644L58.7699 18.7712Z",
    fill: "#CAFFCA"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7806 25.4822L49.2428 42.6524L47.9921 42.3628L54.0569 23.4277L59.5382 24.6986L59.7806 25.4822Z",
    fill: "#CAFFCA"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4338 23.7031L61.4296 20.5933L54.5345 18.9938L56.76 12.0466L54.5311 11.5291L52.3058 18.4772L45.4108 16.8776L44.415 19.9874L51.31 21.587L44.8868 41.6429L47.1155 42.1594L53.5388 22.1035L60.4338 23.7031Z",
    fill: "#03F5AE"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M34.88 37.9044L38.3438 40.0015C38.1717 39.9008 38.0097 39.7837 37.8599 39.652L34.3962 37.5549C34.5457 37.6869 34.7078 37.804 34.88 37.9044Z",
    fill: "#027F5A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3318 5.18604L65.7967 7.28312C65.8339 7.30176 65.8583 7.31574 65.8711 7.3239L62.4074 5.22681C62.3946 5.21982 62.3702 5.20584 62.3318 5.1872",
    fill: "#08091B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4113 5.23142L65.875 7.32851L65.8669 7.32267L62.4031 5.22559H62.4113",
    fill: "#027F5A"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8996 37.9489L57.3633 40.046C57.2665 39.9902 57.1743 39.9267 57.0876 39.8561L53.6227 37.759C53.7102 37.8291 53.8027 37.8925 53.8996 37.9489Z",
    fill: "#027F5A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.2466 15.1869L73.7817 13.0898V13.0887C72.6035 8.4215 70.0574 4.57451 66.2448 2.26538L69.7085 4.36247C73.5247 6.6716 76.0672 10.5197 77.2466 15.1869ZM64.1989 44.4603L64.1996 44.4606C66.4546 42.0127 68.3958 39.2925 69.9784 36.3631C74.326 28.3417 75.4903 19.8555 73.7817 13.0912L77.2466 15.1883C78.954 21.9526 77.7898 30.4376 73.4421 38.4602C71.8598 41.3898 69.9183 44.1099 67.6626 46.5573L67.6626 46.5573C59.707 55.1601 48.9366 58.83 40.7809 54.8467C40.3646 54.6401 39.9625 54.4203 39.5748 54.1873L36.1348 52.1052C36.5163 52.3356 36.9104 52.55 37.3172 52.7484C45.4729 56.7329 56.2433 53.0618 64.1989 44.4603Z",
    fill: "#4B437C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4334_14384",
    x: 14.0938,
    y: 25.5261,
    width: 38.5039,
    height: 43.3545,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_4334_14384"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4334_14384",
    x1: 26.823,
    y1: 22,
    x2: 26.823,
    y2: 76.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C80EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006BA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4334_14384",
    x1: 26.823,
    y1: 22,
    x2: 26.823,
    y2: 76.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE9CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F76B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4334_14384",
    x1: 51.177,
    y1: 0,
    x2: 51.177,
    y2: 54.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C80EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006BA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4334_14384",
    x1: 51.177,
    y1: 0,
    x2: 51.177,
    y2: 54.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE9CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F76B9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMlpCoin);
export default __webpack_public_path__ + "static/media/mlp_coin.d59f343dd408efddd62b3944ba9e282a.svg";
export { ForwardRef as ReactComponent };